import PropTypes from 'prop-types';

const historyShape = PropTypes.object;
const matchShape = PropTypes.object;
const locationShape = PropTypes.object;

export { historyShape, matchShape, locationShape };
